import { controls,grouped } from "../controls";
const outstanding_caste_loans = {
label: "Outstanding Caste Loans",
pageLabel: "Outstanding Caste Loans",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
bulk:{columns:["branch_code","sc","st","christian","sikh","zorashtrian","muslim","jain","women","smf","sc_count","st_count","christian_count","sikh_count","zorashtrian_count","smf_count","muslim_count","jain_count","women_count","total","total_count"] },
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label:"Bulk",uid:"bulk"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Branch Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "branch_code",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "branch_code",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sc"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "sc",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "St"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "st",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Christian"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "christian",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sikh"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "sikh",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Zorashtrian"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "zorashtrian",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Muslim"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "muslim",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Jain"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "jain",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Women"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "women",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Smf"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "smf",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sc Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "sc_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "St Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "st_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Christian Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "christian_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sikh Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "sikh_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Zorashtrian Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "zorashtrian_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Smf Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "smf_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Muslim Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "muslim_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Jain Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "jain_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Women Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "women_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Total"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "total",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Total Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "total_count",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Outstanding Caste Loans",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Branch Code",accessor: "branch_code",},
{Header: "Sc",accessor: "sc",},
{Header: "St",accessor: "st",},
{Header: "Christian",accessor: "christian",},
{Header: "Sikh",accessor: "sikh",},
{Header: "Zorashtrian",accessor: "zorashtrian",},
{Header: "Muslim",accessor: "muslim",},
{Header: "Jain",accessor: "jain",},
{Header: "Women",accessor: "women",},
{Header: "Smf",accessor: "smf",},
]}};
export default outstanding_caste_loans;